import { Buttons } from './Buttons';
import { Forms } from './Forms';
import { Objects } from './Objects';

export const CommonMessage = {
    OBJECTS: Objects,
    FORMS: Forms,
    BUTTONS: Buttons
};
